import {GenCommunity} from '../../../generated/serverModels/GenCommunity';

export class Community extends GenCommunity {

  constructor(community?: Community ) {
    super(community);

  }

}
